import JSONAPISerializer from '@ember-data/serializer/json-api';
import { underscore } from '@ember/string';

export default class TeamSerializer extends JSONAPISerializer {
  keyForAttribute(attr) {
    return underscore(attr);
  }

  serialize() {
    let json = super.serialize(...arguments);
    json.data.attributes.settings = {
      show_uncertainties: json.data.attributes.show_uncertainties,
      show_wfa: json.data.attributes.show_wfa,
    };

    delete json.data.attributes.show_uncertainties;
    delete json.data.attributes.show_wfa;
    delete json.data.attributes.favorite;

    return json;
  }

  normalizeResponse(store, primaryModelClass, payload) {
    if (payload.data.attributes && payload.data.attributes.settings) {
      payload.data.attributes.show_uncertainties =
        payload.data.attributes.settings.show_uncertainties;
      payload.data.attributes.show_wfa =
        payload.data.attributes.settings.show_wfa;
      delete payload.data.attributes.settings;
    }
    return super.normalizeResponse(...arguments);
  }

  normalizeFindAllResponse(store, _, payload) {
    payload.data.forEach((item) => {
      this.normalizeResponse(undefined, undefined, { data: { ...item } });
    });
    return super.normalizeFindAllResponse(...arguments);
  }
}
